<div class="wrapper flex gap-[20px] w-full">
  @if (editable) {
    <app-primary-button
      (handleClick)="save()"
      [isDisabled]="!isFormDirty"
      class="save-button"
      >{{ label }}
    </app-primary-button>
    @if (!hideAddMenu) {
      <div
        [class.disabled]="disableAddMenu"
        [matMenuTriggerFor]="add"
        class="action-button add-button"
        >
        <mat-icon class="add" svgIcon="plus" />
      </div>
    }
    @if (!hideOptionMenu) {
      <div
        [class.disabled]="disableOptionMenu || isWorkflowIssueMenuEmpty"
        [matMenuTriggerFor]="menu"
        class="action-button menu-button"
        >
        <mat-icon class="menu">more_horiz</mat-icon>
      </div>
    }
    <mat-menu #add="matMenu">
      @for (option of addMenuOptions; track option) {
        @if (!isAddMenuOptionHidden(option)) {
          <button
            (click)="option.handler()"
            mat-menu-item
            >
            <div class="add-menu-item flex justify-start items-center">
              <div class="flex justify-center items-center h-[48px]">
                <mat-icon [svgIcon]="option.icon" class="menu-icon" />
              </div>
              <div class="menu-label">{{ option.label }}</div>
            </div>
          </button>
        }
      }
    </mat-menu>
    <mat-menu #menu="matMenu">
      @if (!hideAddOption) {
        <button
          (click)="addNew()"
          mat-menu-item
          >
          <mat-icon svgIcon="plus" />
          {{ addLabel }}
        </button>
      }
      @if (!hideDeleteOption) {
        <button
          (click)="delete()"
          [disabled]="disableDelete"
          mat-menu-item
          >
          <mat-icon [class.icon-disabled]="disableDelete" svgIcon="trash" />
          Delete
        </button>
      }
      @if (showLegacyIssueStatusControls && !isIssueClosed) {
        <button
          (click)="setStatus('close')"
          mat-menu-item>
          <mat-icon svgIcon="pencil-outline" />
          Close
        </button>
      }
      @if (showLegacyIssueStatusControls && isIssueClosed) {
        <button
          (click)="setStatus('reopen')"
          mat-menu-item>
          <mat-icon svgIcon="pencil-outline" />
          Reopen
        </button>
      }
    </mat-menu>
  } @else {
    <app-primary-button
      [isDisabled]="true"
      class="save-button"
      >
      {{ label }}
    </app-primary-button>
    <div
      [class.disabled]="true"
      class="action-button add-button"
      >
      <mat-icon class="add" svgIcon="plus" />
    </div>
    <div
      [class.disabled]="true"
      class="action-button menu-button"
      >
      <mat-icon class="menu">more_horiz</mat-icon>
    </div>
  }
</div>
<input
  #fileInput
  (change)="onFileSelected($event)"
  accept=".png, .jpg, .jpeg, .mp4"
  class="hidden"
  multiple="multiple"
  type="file"
  />
